<template>
  <div>
    <div class="sidebar" ref="sidebar">
      <div class="sidebar-inner">
        <div class="close-wrapper">
          <button type="button" @click="close"></button>
        </div>
        <slot />
        <div class="buttons" v-if="buttonsVisible">
          <button type="button" class="secondary inverted white" @click="close">{{ $t('view.component.common.buttonCancel') }}</button>
          <button type="button" class="primary" @click="confirm">{{ buttonConfirm.title }} <Loader color="#000" v-if="processing" /></button>
        </div>
      </div>
    </div>
    <div class="backdrop" @click="close"></div>
  </div>
</template>

<script>
import Loader from '../Loader'
export default {
  name: 'Sidebar',
  components: { Loader },
  props: {
    sidebarVisible: {
      type: Boolean,
      required: true
    },
    buttonsVisible: {
      type: Boolean,
      default: false,
      required: false
    },
    buttonConfirm: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      escapeHandler: null,
      processing: false
    }
  },
  methods: {
    confirm () {
      this.processing = true
      this.buttonConfirm.callback(() => {
        this.processing = false
        this.close()
      })
    },
    close () {
      if (this.$refs && this.$refs.sidebar) {
        this.$refs.sidebar.classList.remove('visible')
        this.$refs.sidebar.addEventListener('transitionend', () => {
          this.$emit('sidebarClose')
        })
      }
    },
    closeOnPressEscapeKey () {
      this.escapeHandler = e => {
        if (e.keyCode === 27) {
          this.close()
        }
      }
      document.addEventListener('keydown', this.escapeHandler)
    }
  },
  created () {
    document.addEventListener('keydown', this.escapeHandler)
    requestAnimationFrame(() => {
      this.$refs.sidebar.classList.add('visible')
    })
    this.closeOnPressEscapeKey()
  },
  destroyed () {
    document.removeEventListener('keydown', this.escapeHandler)
  }
}
</script>

<style lang="scss" src="../../assets/scss/components/_autotopup_sidebar.scss"></style>
